import React, { useEffect, useState } from "react";

import PageHeading from "../common/PageHeading";
import { useParams } from "react-router-dom";
import { apiHandler } from "../../utils/apiHandler";
import { newImgUrl } from "../../utils/Constants";
import { motion } from "framer-motion";
const FamilyChart = (checkData) => {
    const [id, setId] = useState("");
    const [slug, setSlug] = useState("");
    const [name, setName] = useState("");
    const [family, setFamily] = useState([]);
    const [basicDetails, setBasicDetails] = useState();
    const [members, setMembers] = useState();
    const [backgroundImageWeb, setBackgroundImageWeb] = useState([]);
    const [backgroundImageMob, setBackgroundImageMob] = useState([]);
    const [currentImageIndexWeb, setCurrentImageIndexWeb] = useState(0);
    const [currentImageIndexMob, setCurrentImageIndexMob] = useState(0);
    const [isImageLoaded, setIsImageLoaded] = useState(true);
    const [response, setResponse] = useState({})
    const isMobile = window.innerWidth <= 768;
    const [isSticky, setIsSticky] = useState(false);
    let animationFrameId = null;

    let NewUsername = "";
    const pathArray = window.location.pathname.split("/").filter(Boolean);

    if (pathArray.includes("Login")) {
        // Handle special case when URL contains "Login"
        NewUsername = pathArray[1];
    } else {
        NewUsername = pathArray[0]
    }

    let data = JSON.parse(localStorage.getItem(`logindata_${NewUsername}`))
    const newImgUrl = `https://welcometowedding.com/events/${data?._id}/`
    console.log(newImgUrl);
    
    useEffect(() => {

        const pathSegments = window.location.pathname.split("/");
        if (pathSegments[3] !== undefined) {
            console.log(pathSegments)
            const extractedId = pathSegments[3];   // index 3 = id
            const extractedSlug = decodeURIComponent(pathSegments[4]); // index 4 = slug

            setId(extractedId);
            setSlug(extractedSlug);
            setBackgroundImageWeb([]);

            console.log(extractedId);
            console.log(extractedSlug);

        }

    }, [window.location.pathname, checkData]);

    useEffect(() => {
        const fetchMeetFamily = async () => {
            try {
                const res = await apiHandler.post("/guest/fetch-feature", {
                    _id: id,
                    category: "MeetFamily"
                });
                setResponse(res)


            } catch (err) {
                console.error("Guest login error:", err);
            }
        };

        if (!response?.groomFamilyMembers && id) {
            fetchMeetFamily();
        }
    }, [id])

    useEffect(() => {
        if (response?.groomFamilyMembers || response?.brideFamilyMembers) {
            setFamily(response);
            setBasicDetails(response.basicDetails);

            if (slug === "groomFamilyMembers") {
                setMembers(response.groomFamilyMembers || []);
                setName(response.basicDetails.groomCoverHeading)
                setBackgroundImageWeb(response.basicDetails.familyGroomWebCoverBgSlider);
                setBackgroundImageMob(response.basicDetails.familyGroomMobCoverBgSlider);
            } else if (slug === "brideFamilyMembers") {
                setMembers(response.brideFamilyMembers || []);
                setName(response.basicDetails.brideCoverHeading)
                setBackgroundImageWeb(response.basicDetails.familyWebCoverBgSlider);
                setBackgroundImageMob(response.basicDetails.familyMobCoverBgSlider);
            } else {
                setMembers([]);
                setBackgroundImageWeb(response.basicDetails.familyWebBgSlider);
                setBackgroundImageMob(response.basicDetails.familyMobBgSlider);
            }
            // setCurrentImageIndexWeb(0);

        }
    }, [id, slug, window.location.pathname, checkData, response])


    useEffect(() => {
        const handleScroll = () => {
            if (animationFrameId) {
                cancelAnimationFrame(animationFrameId);
            }
            animationFrameId = requestAnimationFrame(() => {
                const outerElement = document.querySelector('.scroll-bar');
                if (outerElement) {
                    const scrollPosition = outerElement.scrollTop;
                    setIsSticky(scrollPosition > 0);
                }
            });
        };

        const outerElement = document.querySelector('.scroll-bar');
        if (outerElement) {
            outerElement.addEventListener('scroll', handleScroll);
            handleScroll(); // Initial check

            return () => {
                outerElement.removeEventListener('scroll', handleScroll);
                if (animationFrameId) {
                    cancelAnimationFrame(animationFrameId);
                }
            };
        }
    }, []);

    useEffect(() => {
        console.log(backgroundImageWeb.length)
        if (backgroundImageWeb.length) {
            console.log("working")
            const interval = setInterval(() => {
                setCurrentImageIndexWeb((prev) =>
                    prev === backgroundImageWeb.length - 1 ? 0 : prev + 1
                );
            }, 4000);
            return () => clearInterval(interval);
        }

    }, [backgroundImageWeb.length]);

    useEffect(() => {
        if (isMobile) {
            const interval = setInterval(() => {
                setCurrentImageIndexMob((prev) =>
                    prev === backgroundImageMob.length - 1 ? 0 : prev + 1
                );
            }, 4000);
            return () => clearInterval(interval);
        }
    }, [isMobile, backgroundImageMob.length]);
    const containerVariants = {
        hidden: {},
        show: {
            transition: {
                staggerChildren: 0.2,
            },
        },
    };

    const itemVariants = {
        hidden: { opacity: 0, y: 30 },
        show: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } },
    };

    return (
        <div style={{ zIndex: '333333', backgroundColor: 'white', height: '100vh' }}>
            <div className="hidden sm:block">
                <div className="grid grid-cols-12 h-screen black-color common-font">
                    <div
                        className="col-span-5 relative h-screen overflow-hidden bg-cover bg-center bg-no-repeat"
                    // style={{ backgroundImage: `url(${backgroundImg})` }}
                    >
                        {backgroundImageWeb?.length > 0 &&
                            backgroundImageWeb.map((img, index) => (
                                <img
                                    src={newImgUrl + img}
                                    className={`w-full h-full relative z-[-1] object-cover  crossFade__image ${currentImageIndexWeb === index ? 'crossFade__image--active' : ''
                                        }
											transition-all duration-500 ${isImageLoaded ? "blur-lg scale-105" : "blur-0 scale-100"
                                        }
											`}
                                    onLoad={() => setIsImageLoaded(false)}
                                    alt=""
                                />
                            ))}
                        <div
                            className="absolute top-[40px] right-[40px] bottom-[40px] left-[40px] bg-white/0 py-[30px] px-[40px] border-[3px] border-white"
                            style={{
                                boxShadow: "0 0 0 9999px rgba(0, 0, 0, 0.7)",
                            }}
                        ></div>
                    </div>
                    <div className="col-span-7">
                        <div className="h-screen overflow-x-auto  scroll-bar">
                            <div className={`m-0 py-2 w-full w-full stickynav ${isSticky ? "isSticky" : "hideinmobile"}`} >
                                <PageHeading title={name && name} />
                            </div>
                            <motion.div
                                className="flex flex-col "
                                variants={containerVariants}
                                initial="hidden"
                                animate="show"
                            >
                                <div className="p-[40px] grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-7">
                                    {members && members.map(
                                        (item, index) => (
                                            <motion.div
                                                key={index}
                                                variants={itemVariants}
                                                className="  items-start whiteripple cursor-pointer"
                                            >
                                                <div key={item} className="">
                                                    <div className="py-2 px-[20px]">
                                                        {/* box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px; */}
                                                        <div
                                                            className="aspect-square rounded-full overflow-hidden flex justify-center items-center border-[3px] bg-[#ececec] border-black pointer-events-none"
                                                        // style={{boxShadow: "rgba(0, 0, 0, 0.35) 0px 2px 5px"}}
                                                        >
                                                            <div className="border-[3px] border-white rounded-full overflow-hidden ">
                                                                <img
                                                                    src={newImgUrl + item.img}
                                                                    className={`w-full h-full 
											transition-all duration-500 ${isImageLoaded ? "blur-lg scale-105" : "blur-0 scale-100"
                                                                        }
											`}
                                                                    onLoad={() => setIsImageLoaded(false)}
                                                                    alt=""
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="text-center">
                                                        <span className="font-semibold text-[18px]">
                                                            {item.name}
                                                        </span>
                                                        <div className="font-medium">
                                                            {item.relation}
                                                        </div>
                                                    </div>
                                                </div>
                                            </motion.div>
                                        )
                                    )}
                                </div>
                            </motion.div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="block sm:hidden overflow-scroll h-[100vh]" style={{
                height: "100dvh",              // dynamic viewport height (fixes iOS)
                overflowY: "auto",             // vertical scrolling only
                WebkitOverflowScrolling: "touch" // iOS momentum scrolling
            }}>
                <div className="relative w-full h-50 overflow-hidden">
                    {backgroundImageMob?.length > 0 &&
                        backgroundImageMob.map((img, index) => (
                            <img
                                src={newImgUrl + img}
                                className={`object-cover w-full bg-center aspect-[4/3] relative z-[-1]  crossFade__image ${currentImageIndexWeb === index ? 'crossFade__image--active' : ''
                                    }
											transition-all duration-500 ${isImageLoaded ? "blur-lg scale-105" : "blur-0 scale-100"
                                    }
											`}
                                onLoad={() => setIsImageLoaded(false)}
                                alt=""
                            />
                        ))}

                    <div
                        className="absolute top-0 w-full h-full py-[20px] px-[20px]"
                        style={{
                            background:
                                "linear-gradient(0deg, rgba(0,0,0,0.6951374299719888) 0%, rgba(59,59,59,0.26936712184873945) 50%, rgba(0,0,0,0.7) 100%)",
                        }}
                    >
                        <div className="w-full h-full flex justify-center items-center border-[3px] border-white text-center">
                            <h1 className="style-script-regular text-white text-[40px] font-['Baby_Giovani_Script']">
                                {name && name}
                            </h1>
                        </div>
                    </div>
                </div>
                <motion.div
                    className="flex flex-col "
                    variants={containerVariants}
                    initial="hidden"
                    animate="show"
                >
                    <div className="p-[17.5px] grid grid-cols-2 gap-[17.5px]">
                        {members && members.map((item, index) => (
                            <motion.div
                                key={index}
                                variants={itemVariants}
                                className="items-start whiteripple cursor-pointer"
                            >
                                <div
                                    key={item}
                                    className="rounded-[10px] overflow-hidden relative"
                                >
                                    <img
                                        src={newImgUrl + item.img}
                                        alt=""
                                        className={`w-full h-full 
											transition-all duration-500 ${isImageLoaded ? "blur-lg scale-105" : "blur-0 scale-100"
                                            }
											`}
                                        onLoad={() => setIsImageLoaded(false)}
                                    />
                                    <div className="w-full h-full absolute top-0 bg-black/60 flex flex-col items-center gap-2 py-2">
                                        <div className="aspect-square  rounded-full overflow-hidden border-2 border-white bg-[#ececec] pointer-events-none">
                                            <img src={newImgUrl + item.img}
                                                className={`
											transition-all duration-500 ${isImageLoaded ? "blur-lg scale-105" : "blur-0 scale-100"
                                                    }
											`}
                                                onLoad={() => setIsImageLoaded(false)}
                                                alt="" />
                                        </div>
                                        <div className="text-white text-center">
                                            <span className="font-semibold">
                                                {item.name}
                                            </span>
                                            <span className="block">{item.relation}</span>
                                        </div>
                                    </div>
                                </div>
                            </motion.div>
                        ))}
                    </div>
                </motion.div>
            </div>
        </div>
    );
};

export default FamilyChart;
